import { gql } from "graphql-request";

export const homepageQuery = gql`
query home {
    Homepage(id: "d5cf28d3-6497-41bc-9d17-b23ea954a4dc") {
    introduction
    projects {
      project_title
      slug {current}
      _id
      project_summary
      project_date
      project_hero_image {image{asset{url}, alt_text}}
      project_image_header {image{image{asset{url},alt_text}}, color},
      project_image_footer {image{image{asset{url}, alt_text}}, color},
      project_content_images {
        color,
        project_image_1 {image{asset{url}, alt_text}},
        project_image_2 {image{asset{url}, alt_text}},
        project_image_3 {image{asset{url}, alt_text}},
        project_image_4 {image{asset{url}, alt_text}},
        project_image_5 {image{asset{url}, alt_text}},
        project_image_6 {image{asset{url}, alt_text}}
      }
    }
  }
  }
`;